//@flow

import React from "react";

import AirplaneIcon from "@/images/icons/icon-airplane.svg";
import apiIcon from "@/images/icons/icon-api.svg";
import BikeIcon from "@/images/icons/icon-bike.svg";
import BoxIcon from "@/images/icons/icon-box.svg";
import BoxOnWheelsIcon from "@/images/icons/icon-box-on-wheels.svg";
import BoxSearchIcon from "@/images/icons/icon-box-search.svg";
import curiousIcon from "@/images/icons/icon-bru-curious.svg";
import handIcon from "@/images/icons/icon-bru-hand.svg";
import headIcon from "@/images/icons/icon-bru-head.svg";
import heartIcon from "@/images/icons/icon-bru-heart.svg";
import bruIconLight from "@/images/icons/icon-bru-light.svg";
import bruIcon from "@/images/icons/icon-bru-logo.svg";
import ClimateActionIcon from "@/images/icons/icon-climate-action.svg";
import ComputerIcon from "@/images/icons/icon-computer.svg";
import OperationsIcon from "@/images/icons/icon-cutting-edge-operations.svg";
import EconomicGrowthIcon from "@/images/icons/icon-economic-growth.svg";
import Eutrophication from "@/images/icons/icon-eutrophication.svg";
import FactoriesIcon from "@/images/icons/icon-factories.svg";
import FinancialSupportIcon from "@/images/icons/icon-financial-support.svg";
import ForkliftTruckIcon from "@/images/icons/icon-forklift-truck.svg";
import GlobalWarming from "@/images/icons/icon-global-warming.svg";
import HourglassBoxIcon from "@/images/icons/icon-hourglass-box.svg";
import DesignStudioIcon from "@/images/icons/icon-in-house-design-studio.svg";
import SampleProductionIcon from "@/images/icons/icon-in-house-sample-production.svg";
import InfoBoxIcon from "@/images/icons/icon-info-box.svg";
import LaptopIcon from "@/images/icons/icon-laptop.svg";
import LogisticsIcon from "@/images/icons/icon-logistic-solutions.svg";
import MarketingIcon from "@/images/icons/icon-marketing-support.svg";
import NewspaperBoxIcon from "@/images/icons/icon-newspaper-box.svg";
import LabIcon from "@/images/icons/icon-owned-certified-lab.svg";
import LabCenteredIcon from "@/images/icons/icon-owned-certified-lab-centered.svg";
import PartnershipsIcon from "@/images/icons/icon-partnerships.svg";
import SalesforceIcon from "@/images/icons/icon-proactive-salesforce.svg";
import RecycleBoxIcon from "@/images/icons/icon-recycle-box.svg";
import ReduceEnergyIcon from "@/images/icons/icon-reduce-energy.svg";
import ResourceDepletion from "@/images/icons/icon-resource-depletion.svg";
import ResponsibleProductionIcon from "@/images/icons/icon-responsible-production.svg";
import SolarPanelsIcon from "@/images/icons/icon-solar-panels.svg";
import SupplyChainIcon from "@/images/icons/icon-supply-chain.svg";
import TemperatureEarthIcon from "@/images/icons/icon-temperature-earth.svg";
import TransparencyTraceAbilityIcon from "@/images/icons/icon-transparency-traceability.svg";
import TruckIcon from "@/images/icons/icon-truck.svg";
import visualizationIcon from "@/images/icons/icon-visualization.svg";
import WarehouseIcon from "@/images/icons/icon-warehouse.svg";
import WindmillIcon from "@/images/icons/icon-windmill.svg";
import { classNameOf } from "@/utils";

export type Icon =
    | "airplane"
    | "api"
    | "bike"
    | "box-on-wheels"
    | "box-search"
    | "box"
    | "bru"
    | "bru-light"
    | "climate-action"
    | "computer"
    | "curious"
    | "design-studio"
    | "digital-textures"
    | "economic-growth"
    | "eutrophication"
    | "factories"
    | "financial-support"
    | "forklift-truck"
    | "global-warming"
    | "hand"
    | "head"
    | "heart"
    | "hourglass-box"
    | "info-box"
    | "lab-centered"
    | "lab"
    | "laptop"
    | "logistics"
    | "marketing"
    | "newspaper-box"
    | "operations"
    | "partnerships"
    | "recycle-box"
    | "reduce-energy"
    | "resource-depletion"
    | "responsible-production"
    | "salesforce"
    | "sample-production"
    | "solar-panels"
    | "supply-chain"
    | "temperature-earth"
    | "transparency-traceability"
    | "truck"
    | "visualization"
    | "warehouse"
    | "windmill";

type IconSize = "xs" | "sm" | "md" | "lg";

type Props = {
    icon: Icon,
    size?: IconSize,
};

function getIconSrc(icon: Icon): string {
    switch (icon) {
        case "design-studio":
            return DesignStudioIcon;
        case "financial-support":
            return FinancialSupportIcon;
        case "lab":
            return LabIcon;
        case "lab-centered":
            return LabCenteredIcon;
        case "logistics":
            return LogisticsIcon;
        case "marketing":
            return MarketingIcon;
        case "operations":
            return OperationsIcon;
        case "salesforce":
            return SalesforceIcon;
        case "sample-production":
            return SampleProductionIcon;
        case "head":
            return headIcon;
        case "hand":
            return handIcon;
        case "heart":
            return heartIcon;
        case "curious":
            return curiousIcon;
        case "api":
            return apiIcon;
        case "visualization":
            return visualizationIcon;
        case "bru":
            return bruIcon;
        case "bru-light":
            return bruIconLight;
        case "factories":
            return FactoriesIcon;
        case "forklift-truck":
            return ForkliftTruckIcon;
        case "hourglass-box":
            return HourglassBoxIcon;
        case "newspaper-box":
            return NewspaperBoxIcon;
        case "recycle-box":
            return RecycleBoxIcon;
        case "temperature-earth":
            return TemperatureEarthIcon;
        case "eutrophication":
            return Eutrophication;
        case "global-warming":
            return GlobalWarming;
        case "resource-depletion":
            return ResourceDepletion;
        case "warehouse":
            return WarehouseIcon;
        case "solar-panels":
            return SolarPanelsIcon;
        case "bike":
            return BikeIcon;
        case "laptop":
            return LaptopIcon;
        case "box-on-wheels":
            return BoxOnWheelsIcon;
        case "supply-chain":
            return SupplyChainIcon;
        case "economic-growth":
            return EconomicGrowthIcon;
        case "partnerships":
            return PartnershipsIcon;
        case "climate-action":
            return ClimateActionIcon;
        case "responsible-production":
            return ResponsibleProductionIcon;
        case "transparency-traceability":
            return TransparencyTraceAbilityIcon;
        case "box":
            return BoxIcon;
        case "info-box":
            return InfoBoxIcon;
        case "computer":
            return ComputerIcon;
        case "truck":
            return TruckIcon;
        case "reduce-energy":
            return ReduceEnergyIcon;
        case "box-search":
            return BoxSearchIcon;
        case "airplane":
            return AirplaneIcon;
        case "windmill":
            return WindmillIcon;
        default:
            return DesignStudioIcon;
    }
}

const BruIcon = ({icon, size}: Props): React$Element<"div"> => {
    const classNames = classNameOf("bru-icon", size || "");
    return (
        <div className={classNames}>
            <img src={getIconSrc(icon)} alt={`${icon} icon`} />
        </div>
    );
};

export default BruIcon;
